import CandidateSort, { CandidateSortProps } from './CandidateSort.component';

export type CandidateSortType = CandidateSortProps;

export default CandidateSort;
